import {
  SET_DATA_DAILY_SHARE,
  SET_DATA_RANKING,
  SET_DATA_MONTHLY_SHARE,
  SET_DATA_DAILY_REPORTS
} from '../constants/actionTypes';

export const initialState = {
  dataDailyShare: null,
  dataRanking: null,
  dataMonthlyShare: null,
  dataDailyReports: null
};

export default (state = initialState, action) => {
  const {
    type,
    dataDailyShare,
    dataRanking,
    dataMonthlyShare,
    dataDailyReports
  } = action;

  switch (type) {
    case SET_DATA_DAILY_SHARE:
      return {
        ...state,
        dataDailyShare
      };

    case SET_DATA_RANKING:
      return {
        ...state,
        dataRanking
      };

    case SET_DATA_MONTHLY_SHARE:
      return {
        ...state,
        dataMonthlyShare
      };

    case SET_DATA_DAILY_REPORTS:
      return {
        ...state,
        dataDailyReports
      };

    default:
      return state;
  }
};
